import AdminImageUpload from "../admin-pages/admin-image-upload";

export default function SettingsTabComponent() {
    return <div>
        <AdminImageUpload />
    </div>;
}